import { motion } from 'framer-motion';

const  HeroSection = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <video
        autoPlay
        loop
        muted
        className="absolute inset-0 w-full h-full object-cover z-0"
        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
      />
      <div className="relative z-10 h-full flex items-center justify-center bg-black/50">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center text-white max-w-3xl"
        >
          <h1 className="text-5xl font-bold mb-4">Building Resilience & Justice</h1>
          <p className="text-xl mb-6">We partner with communities worldwide to end poverty and injustice.</p>
          <button className="bg-red-600 hover:bg-red-700 transition px-6 py-3 rounded">
            Get Involved
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection